export default "https://assets-v2.scaler.com/packs/files/reminder-heading.2dbbb8.webp";